import Service from './service.js';
import { errorMessage } from '@/utils/message.js';

export default {
  props: {
    agentId: {
      type: Number | String,
      default: null
    },
    type: {
      type: String,
      default: ''
    },
    changeAgentFlag: {
      type: Boolean,
      default: false
    },
    bidId: {
      type: Number | String,
      default: ''
    }
  },
  data() {
    return {
      agentList: [],
      agentShowDialog: false,
      defaultAgentId: '',
      tempAgentInfo: { },
      defaultAgentInfo: {
        bidAgentOrgName: '',
        creditCode: '',
        bidAgentOrgContactName: '',

        bidAgentOrgAddress: ''
      }
    };
  },
  watch: {
    agentId(value, oldValue) {
      if(!value && oldValue) {
        this.$emit('update:agentId', oldValue);
      } else if(value && oldValue) {
        this.defaultAgentInfo = this.agentList.find(item => item.bidAgentOrgId === Number(this.agentId));
      }
      this.$emit('getAgentInfo', this.defaultAgentInfo);
    },
    changeAgentFlag (value) {
      if(value) {
        this.getBidAgentOrgList();
        this.agentShowDialog = true;
      }
    },
    agentShowDialog (flag) {
      !flag && this.$emit('update:changeAgentFlag', false);
    }
  },
  created() {
    this.$nextTick(() => {
      this.defaultAgentId = this.agentId;
      this.getBidAgentOrgList();
    });
  },
  methods: {
    // 获取银行卡列表
    getBidAgentOrgList(){
      let that = this;
      Service.getBidAgentOrgList().then(res => {
        if (res && res.code === '0') {
          that.agentList = res.data;
          // 如果传过来的有银行ID
          if(that.agentId) {
            that.defaultAgentInfo = res.data.find(item => item.bidAgentOrgId === Number(that.agentId));
          } else {
            // 如果没有 就取第一个
            that.defaultAgentInfo = res?.data[0];
            that.defaultAgentId = that.defaultAgentInfo.bidAgentOrgId;
            that.$emit('update:agentId', that.defaultAgentId);
          }
          this.$emit('getAgentInfo', this.defaultAgentInfo);
        } else {
          errorMessage(res && res.reason);
        }
      }, (error) => {
        if (error && error.data && error.data.reason) {
          errorMessage(error.data.reason);
        }
      });
    },
    // 选择招标代理机构
    selectedAgent(agentObj) {
      this.defaultAgentId = agentObj.bidAgentOrgId;
      this.tempAgentInfo = agentObj;
    },
    // 确认选择
    confirmSelected () {
      if(this.tempAgentInfo.bidAgentOrgId) {
        this.defaultAgentInfo = this.tempAgentInfo;
      }
      this.$emit('update:agentId', this.defaultAgentInfo.bidAgentOrgId);
      this.$emit('getAgentInfo', this.defaultAgentInfo);
      this.agentShowDialog = false;
    },
    // 添加银行卡
    toAddAgentPage () {
      this.$router.push('/person-center/account-info/agent-account-manage/add');
    },
    // 确认变更银行卡
    confirmChangeAgent () {
      let params = {
        bidId: this.bidId,
        agentId: this.defaultAgentId
      };
      Service.updateSignAgent(params).then(({code}) => {
        if (code === '0') {
          this.$successMessage('变更成功');
          this.agentShowDialog = false;
          this.$emit('update:changeAgentFlag', false);
        }
      }).catch(() => {
        this.$errorMessage('变更成功');
      });
    }
  }
};
